import { fragments as artOrderStatusFragments } from "../../application/apps/ArtApp/components/ArtOrderStatus/graph";
import { gql } from "@apollo/client";

const markOrderAsProofCompletedMutation = gql`
  mutation ($orderId: ID!) {
    markOrderAsProofCompleted(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...ArtOrderStatus_order
      }
      succeeded
    }
  }
  ${artOrderStatusFragments.order}
`;

export default markOrderAsProofCompletedMutation;
